module.exports = __webpack_public_path__ + "media/images/Newicon-a9dc90f5.png";